import {encode} from 'iconv-lite';

export class UrlUtil {
    public static isUTF8(charset: string): boolean {
        if (!charset) {
            return true;
        }
        charset = charset.toLowerCase();

        return charset === 'utf8' || charset === 'utf-8';
    }

    public static  urlencode(str: string, charset: string): string {
        if (!charset || UrlUtil.isUTF8(charset)) {
            return encodeURIComponent(str);
        }
        const buf = encode(str, charset);
        let encodeStr = '';
        let ch = '';

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < buf.length; i++) {
            ch = buf[i].toString(16);
            if (ch.length === 1) {
                ch = '0' + ch;
            }
            encodeStr += '%' + ch;
        }
        encodeStr = encodeStr.toUpperCase();

        return encodeStr;
    }
}
